export enum AUTH_PROVIDERS_ENUM {
    AuthLockOptions = 'AuthLockOptions'
}
